import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';

import {
  Textarea as LDSTextarea,
  TextareaProps,
} from '@letsdothis/lds/lib/candidate/Textarea';

import { FieldProps } from '../types';
import { getAutofillString } from '../utils';
import FieldWrapper from './FieldWrapper';

type Props = Omit<TextareaProps, 'error'> &
  FieldProps & { defaultValue?: string };

export const Textarea: React.FC<Props> = (props) => {
  const { control } = useFormContext();
  const {
    id,
    required = false,
    validation,
    title,
    error,
    hideLabel,
    description,
    defaultValue,
    ...rest
  } = props;

  return (
    <FieldWrapper {...{ id, required, title, error, hideLabel, description }}>
      <Controller
        control={control}
        name={id}
        rules={{
          required: required && `${title} required`,
          ...validation,
        }}
        defaultValue={defaultValue}
        as={
          <LDSTextarea
            {...{
              id,
              required,
              error: !!error,
              name: id,
              autoComplete: getAutofillString(id),
              maxAutoExpandedHeight: 120,
              ...rest,
            }}
          />
        }
      />
    </FieldWrapper>
  );
};
